import { isFilled } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText } from '@prismicio/react';
import { formatDistance } from 'date-fns';
import { fr } from 'date-fns/locale';

import { PressDocumentData } from '@/prismicio-types';

import {
  cardWrapper,
  date,
  imageWrapper,
  imageWrapperImg,
  logoWrapper,
  logoWrapperImg,
  title,
} from './index.css';

type PressArticleCardProps = {
  article: PressDocumentData;
};

export function PressArticleCard({ article }: PressArticleCardProps) {
  return (
    <PrismicNextLink className={cardWrapper} field={article.link}>
      <section className={imageWrapper}>
        <PrismicNextImage className={imageWrapperImg} field={article.image} />
      </section>
      <section className={logoWrapper}>
        <PrismicNextImage className={logoWrapperImg} field={article.logo} />
      </section>
      {isFilled.timestamp(article.published_at) && (
        <span className={date}>
          {formatDistance(article.published_at ?? new Date(), new Date(), {
            locale: fr,
            addSuffix: true,
          })}
        </span>
      )}
      <PrismicRichText
        components={{
          paragraph: ({ children }) => (
            <span className={title}>{children}</span>
          ),
        }}
        field={article.title}
      />
    </PrismicNextLink>
  );
}
